<template>
  <div class="Sys-warp">
    <img src="../../assets/banner.png" class="banner-img"/>
    <div class="menu-container">
      <div class="menu" @click="jumpInApply">
        企业入驻申请
      </div>
      <div class="menu" @click="jumpChangeApply">
        工商变更申请
      </div>
<!--      <div class="menu" @click="jumpProofForUseApply">-->
<!--        房屋使用证明申请-->
<!--      </div>-->
      <div class="menu" @click="jumpQuery">
        申请进度查询
      </div>
    </div>

    <change-apply-verify-company-info-dialog v-if="verifyDialogVisible"
                                             ref="verifyDialog"></change-apply-verify-company-info-dialog>
    <in-apply-verify-company-info-dialog v-if="inApplyVerifyDialogVisible"
                                         ref="inApplyVerifyDialog"></in-apply-verify-company-info-dialog>
  </div>
</template>

<script>
import ChangeApplyVerifyCompanyInfoDialog from "@/component/ChangeApplyVerifyCompanyInfoDialog";
import InApplyVerifyCompanyInfoDialog from "@/component/InApplyVerifyCompanyInfoDialog";
import constant from "@/utils/constant";

export default {
  name: 'Home',
  components: {
    ChangeApplyVerifyCompanyInfoDialog,
    InApplyVerifyCompanyInfoDialog
  },
  data() {
    return {
      verifyDialogVisible: false,
      inApplyVerifyDialogVisible: false,
    }
  },
  created() {
  },
  methods: {
    jumpInApply() {
      this.inApplyVerifyDialogVisible = true
      this.$nextTick(() => {
        this.$refs.inApplyVerifyDialog.init()
      })
      // this.$router.push({
      //   name: 'InApply',
      // });
    },
    jumpChangeApply() {
      this.$confirm('原注册地在功能区外的企业，请进行入驻申请，原注册地在功能区内的企业，可以进行工商变更申请，确定发起工商变更申请吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        // this.$router.push({
        //   name: 'ChangeApply',
        // });
        this.verifyDialogVisible = true
        this.$nextTick(() => {
          this.$refs.verifyDialog.init(constant.BUSINESS_TYPE_CHANGE)
        })
      }).catch(() => {
      });
    },
    jumpProofForUseApply() {
      this.verifyDialogVisible = true
      this.$nextTick(() => {
        this.$refs.verifyDialog.init(constant.BUSINESS_TYPE_PROOF_OF_USE)
      })
    },
    jumpQuery() {
      this.$router.push({
        name: 'Query',
      });
    },
  },
}
</script>
<style scoped>
.banner-img {
  width: 100%;
  height: auto;
}

.menu-container {
  display: flex;
  justify-content: space-around;
  margin-top: 100px;
  margin-bottom: 100px;
}

.menu {
  border-radius: 34px;
  border: 1px solid rgba(206, 206, 206, 1);
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 13px 17px 0px rgba(0, 0, 0, 0.1);
  width: 270px;
  height: 270px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  color: #4F76B6;
}
</style>
